<script setup>
import { defineProps, ref } from "vue";
import ProfilDewas from "@/Components/Web/ProfilDewas.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
const props = defineProps({
  formasi: {
    type: Object,
    required: true,
  },
});

const isModalOpen = ref(false);
const viewFormasi = ref(null);
const isLoading = ref(false);

const viewProfile = async (id) => {
  isLoading.value = true;
  isModalOpen.value = true;
  viewFormasi.value = null;
  try {
    const response = await fetch(`/pejabat/${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      throw new Error("Response is not JSON");
    }
    const data = await response.json();
    viewFormasi.value = data.formasidata;
  } catch (error) {
    console.error("Error fetching data:", error.message);
  } finally {
    isLoading.value = false;
  }
};
</script>
<style scoped>
.ribbon {
  background: linear-gradient(90deg, #2563eb 0%, #1e40af 100%);
  color: #fff;
  font-weight: bold;
  font-size: 1.5rem;
  padding: 0.75rem 2rem;
  border-radius: 0;
  margin: 0 auto 2rem auto;
  width: fit-content;
  box-shadow: 0 4px 12px rgba(238, 210, 0, 0.08);
  letter-spacing: 1px;
}
</style>
<template>
  <div>
    <section class="pb-15">
      <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
        <div class="mx-auto max-w-[1170px] px-4 sm:px-8 xl:px-0 relative z-1">
          <div class="flex flex-wrap gap-x-8 gap-y-8 lg:grid lg:grid-cols-3 lg:gap-8">
            <!-- Author Item -->
            <a v-for="(author, index) in formasi.data" :key="author.id || index" @click="viewProfile(author.id)"
              href="#" class="h-full group">
              <div
                class="flex flex-col h-full overflow-hidden transition-all border border-gray-3 bg-gray group-hover:bg-white group-hover:drop-shadow-1 group-hover:-translate-y-2">
                <!-- Full Card Photo Background -->
                <div class="relative flex-1 min-h-[300px]">
                  <img v-if="author.dosen && author.dosen.foto" :src="author.dosen.foto.startsWith('http')
                    ? author.dosen.foto
                    : '/storage/' + author.dosen.foto
                    " alt="Foto Dosen" class="object-cover w-full h-full" />
                  <div v-else class="flex items-center justify-center w-full h-full bg-gray-200">
                    <div class="text-6xl text-gray-400">👤</div>
                  </div>

                  <!-- Gradient Overlay -->
                  <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>

                  <!-- Content Overlay -->
                  <div class="absolute bottom-0 left-0 right-0 p-5 text-white">
                    <div class="text-center">
                      <h3 class="mb-2 text-xl font-semibold">
                        {{ author.dosen.nama }}
                      </h3>
                      <div class="w-full h-1 mb-4 bg-gradient-to-r from-blue-500 to-yellow-400"></div>
                      <p class="text-gray-200">
                        {{ author.jabatan.namajabatan }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <!-- Modal positioned absolutely at the top, above the slider -->
          <Loading v-if="isLoading" :active="isLoading" :is-full-page="true" />
          <ProfilDewas v-if="isModalOpen && !isLoading" v-model:isOpen="isModalOpen" :formasi="viewFormasi"
            :title="`${viewFormasi?.jabatan?.namajabatan}`" style="position: fixed; z-index: 9999; left: 0; top: 0" />
        </div>
      </div>
    </section>
  </div>
</template>
